export const StorageKeys = {
  CONVERSATIONS: 'CONVERSATIONS',
  CURRENT_CONVERSATIONS: 'CURRENT_CONVERSATIONS',
  NAV_HISTORY: 'NAV_HISTORY',
  USER_HISTORIC_CONVERSATIONS: 'USER_HISTORIC_CONVERSATIONS',
  USER_SETTINGS: 'USER_SETTINGS',
  USER_TOKEN: 'USER_TOKEN'
};
